const hasInitialConfig = Object.prototype.hasOwnProperty.call(window, 'sideChefConfig')

let managed = hasInitialConfig
let analyticsAllowed = managed ? window.sideChefConfig?.analyticsAllowed === true : true
const listeners = new Set()

export const isAnalyticsConsentManaged = () => managed
export const isAnalyticsAllowed = () => analyticsAllowed

export const subscribeToAnalyticsConsent = listener => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const setAnalyticsAllowed = value => {
  const nextAllowed = value === true
  if (managed && analyticsAllowed === nextAllowed) return

  managed = true
  analyticsAllowed = nextAllowed
  listeners.forEach(listener => listener(analyticsAllowed))
}

export const withAnalyticsConsent = url => {
  if (!managed) return url
  const parsedUrl = new URL(url, window.location.href)
  parsedUrl.searchParams.set('analyticsAllowed', String(analyticsAllowed))
  return parsedUrl.toString()
}
